import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { shouldRenderProfessionalTrialBanner as ShouldRenderProfessionalTrialBannerQuery } from './types/shouldRenderProfessionalTrialBanner';

export const shouldRenderProfessionalTrialBannerQuery = gql`
  query shouldRenderProfessionalTrialBanner($accountId: Int!) {
    account(id: $accountId) {
      id
      isTrialing
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<ShouldRenderProfessionalTrialBannerQuery>(
    shouldRenderProfessionalTrialBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  return Boolean(data?.account?.isTrialing);
};
